import React, { useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import { useNavigate } from 'react-router-dom'
import { Col, Nav, Row, Spinner, Tab } from 'react-bootstrap'
import Card from '../../../../components/Card'
import ViewKapalHeader from './view/ViewKapalHeader'
import ViewKapalDok from './view/ViewKapalDok'

const ViewEditKapal = () => {
    const [selectedTab, setSelectedTab] = useState('entitas')
    const [dataHeader, setDataHeader] = useState({})
    const [dataDokumen, setDataDokumen] = useState({})
    const [loading, setLoading] = useState(false)
    const [nomorAjuKapal, setNomorAjuKapal] = useState(null)

    let kapalService = useMemo(() => new KapalService(), [])

    const navigate = useNavigate()

    const handleSelectTab = async (key) => {
        setLoading(true)
        let nomorAju = localStorage.getItem('nomorAjuKapalStorage')
        setSelectedTab(key)
        let response
        try {
            if (key === 'entitas') {
                if (nomorAju !== null) {
                    response = await kapalService.getKapalHeaderById(nomorAju)
                    setDataHeader(response.data)
                } else {
                    setDataHeader({})
                }
            } else if (key === 'dokumen') {
                if (nomorAju !== null) {
                    response = await kapalService.listKapalDokumen(nomorAju, 0, 10)
                    setDataDokumen(response.data)
                } else {
                    setDataDokumen({})
                }
            }
        } catch (error) {
            setDataHeader({})
            setDataDokumen({})
        }
        setLoading(false)
    }

    const backToList = () => {
        navigate('/pbumku/kapal/draft-kapal')
    }

    useState(() => {
        let nomorAju = localStorage.getItem('nomorAjuKapalStorage')
        const fetchAllOptions = async (noaju) => {
            setLoading(true)
            try {
                let response
                if (selectedTab === 'entitas') {
                    if (nomorAju !== null) {
                        response = await kapalService.getKapalHeaderById(nomorAju)
                        setDataHeader(response.data)
                    } else {
                        setDataHeader({})
                    }
                } else if (selectedTab === 'dokumen') {
                    if (nomorAju !== null) {
                        setNomorAjuKapal(nomorAju)
                        response = await kapalService.listKapalDokumen(nomorAju, 0, 10)
                        setDataDokumen(response.data)
                    } else {
                        setDataDokumen({})
                    }
                }
            } catch (error) {
                setDataHeader({})
                setDataDokumen({})
            }
            setLoading(false)
        }
        fetchAllOptions(nomorAju)
        setNomorAjuKapal(nomorAju)
    }, [selectedTab])

    return (
        <div>
            <Row>
                <Col sm="12" lg="13">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Form Permohonan Sertifikasi CPIB Kapal</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Tab.Container defaultActiveKey="entitas" onSelect={handleSelectTab} activeKey={selectedTab}>
                                <Nav variant='tabs'>
                                    <Nav.Item>
                                        <Nav.Link eventKey={'entitas'}>Entitas</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey={'dokumen'} disabled={nomorAjuKapal === null}>Dokumen</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey={'entitas'}>
                                        {loading && <Spinner animation='border' />}
                                        <ViewKapalHeader dataHeader={dataHeader} cancelHeader={backToList} saveHeader={handleSelectTab} />
                                    </Tab.Pane>
                                </Tab.Content>
                                <Tab.Content>
                                    <Tab.Pane eventKey={'dokumen'}>
                                        {loading && <Spinner animation='border' />}
                                        <ViewKapalDok dataDokumen={dataDokumen} saveDokumen={backToList} cancelDokumen={handleSelectTab} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default ViewEditKapal